import { Link } from 'react-router-dom';
import { useTranslation } from '@/lib/i18n';
import { Server, Mail, MapPin } from 'lucide-react';
import { LanguageSwitcher } from '@/components/layout/LanguageSwitcher';

const footerLinks = {
  products: [
    { key: 'gameservers', href: '/gameservers' },
    { key: 'vps', href: '/vps/kvm' },
    { key: 'dedicated', href: '/dedicated' },
    { key: 'webhosting', href: '/webhosting/ssd' },
    { key: 'domains', href: '/domains/check' },
    { key: 'teamspeak', href: '/teamspeak' },
  ],
  //company: [
    //{ key: 'about', href: '/about' },
    //{ key: 'team', href: '/team' },
    //{ key: 'partners', href: '/partners' },
    //{ key: 'careers', href: '/careers' },
  //],
  legal: [
    { key: 'imprint', href: 'https://deinserverhost.de/impressum', target: '_blank' },
    { key: 'privacy', href: 'https://deinserverhost.de/datenschutz', target: '_blank' },
    { key: 'terms', href: 'https://deinserverhost.de/agb', target: '_blank' },
    { key: 'cookies', href: '/cookie-settings' },
  ],
  support: [
    { key: 'faq', href: '/faq' },
    { key: 'ticket', href: 'https://deinserverhost.de/store/submitticket.php', external: true },
    { key: 'status', href: 'https://status.deinserverhost.de', external: true },
  ],
};

const socialLinks = [
  {
    icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    href: 'https://twitter.com/Deinserverhost',
    label: 'X (Twitter)'
  },
  {
    icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
      </svg>
    ),
    href: 'https://discord.deinserverhost.de',
    label: 'Discord'
  },
  {
    icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
    href: 'https://www.tiktok.com/@deinserverhost',
    label: 'TikTok'
  },
  {
    icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    href: 'https://youtube.com/@deinserverhost',
    label: 'YouTube'
  },
];

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const renderLink = (link, section) => {
    const label = section === 'products' ? t(`nav.${link.key}`) : t(`footer.${link.key}`);
    if (link.external) {
      return (
        <a
          key={link.key}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground hover:text-foreground transition-colors"
          title={label}
        >
          {label}
        </a>
      );
    }
    return (
      <Link
        key={link.key}
        to={link.href}
        target={link.target}
        className="text-muted-foreground hover:text-foreground transition-colors"
        title={label}
      >
        {label}
      </Link>
    );
  };

  return (
    <footer className="bg-card border-t border-border" role="contentinfo">
      <div className="container-main py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <Link to="/" className="inline-block mb-4" aria-label="DeinServerHost" title="DeinServerHost - Home">
              <img src="/black.svg" alt="DeinServerHost" title="DeinServerHost" className="h-10 w-auto block dark:hidden" />
              <img src="/white.svg" alt="DeinServerHost" title="DeinServerHost" className="h-10 w-auto hidden dark:block" />
            </Link>
            <p className="text-muted-foreground mb-6 max-w-sm">
              {t('footer.tagline')}
            </p>

            {/* Contact Info */}
            <div className="space-y-3 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@deinserverhost.de" className="hover:text-foreground transition-colors">
                  info@deinserverhost.de
                </a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Germany</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
                  aria-label={social.label}
                  title={social.label}
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-bold text-foreground mb-4">{t('footer.products')}</h3>
            <nav className="flex flex-col gap-3" aria-label="Products">
              {footerLinks.products.map((link) => renderLink(link, 'products'))}
            </nav>
          </div>

          {/* Company */}
            {/*
            <div>
                <h3 className="font-bold text-foreground mb-4">{t('footer.company')}</h3>
                <nav className="flex flex-col gap-3" aria-label="Company">
                  {footerLinks.company.map((link) => renderLink(link))}
                </nav>
              </div>
            */}

          {/* Legal */}
          <div>
            <h3 className="font-bold text-foreground mb-4">{t('footer.legal')}</h3>
            <nav className="flex flex-col gap-3" aria-label="Legal">
              {footerLinks.legal.map((link) => renderLink(link))}
            </nav>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-bold text-foreground mb-4">{t('footer.support')}</h3>
            <nav className="flex flex-col gap-3" aria-label="Support">
              {footerLinks.support.map((link) => renderLink(link))}
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            {t('footer.copyright').replace('{year}', currentYear)}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted-foreground flex items-center gap-2">
              <Server className="w-4 h-4" />
              Hosted in Germany
            </span>
            <div className="w-px h-4 bg-border" />
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
